module.exports = __webpack_public_path__ + "components/media-kit/static/logo--Intersport-b90dbe262988e9fa6eed4d1e798f8a7d.svg";